import { render, staticRenderFns } from "./number.vue?vue&type=template&id=03606bd9&lang=pug&"
import script from "./number.vue?vue&type=script&lang=js&"
export * from "./number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports